export default __webpack_public_path__ + "static/media/ally_l3.4540fab7.png";